var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%","overflow":"hidden"}},[(_vm.xData.length === 0)?_c('div',{staticClass:"nothing-data"}):_c('div',{ref:"wrap",style:({height: '100%', margin: 'auto 0', zoom: 1 / this.golobleObject.zoom}),attrs:{"id":"bar"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e849c9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/monitoring/weiNingComponents/rightCenterAlarm.vue
// module id = null
// module chunks = 